import { useCallback, useEffect, useRef, useState } from 'react';
import { listarSugestoesChatIa } from '../../../api/chatIa';

const ATRASO_BUSCA_MS = 250;

const useSugestoesHook = (termo, { buscarSemTermo = false } = {}) => {
  const [sugestoes, setSugestoes] = useState([]);
  const [indiceSelecionado, setIndiceSelecionado] = useState(null);
  const timeoutRef = useRef(null);
  const requisicaoRef = useRef(null);

  const limpar = useCallback(() => {
    clearTimeout(timeoutRef.current);
    requisicaoRef.current?.abort();
    requisicaoRef.current = null;
    setSugestoes([]);
    setIndiceSelecionado(null);
  }, []);

  useEffect(() => {
    const termoLimpo = termo.trim();
    const deveBuscar = termoLimpo.length >= 2 || (buscarSemTermo && termoLimpo.length === 0);

    clearTimeout(timeoutRef.current);
    requisicaoRef.current?.abort();

    if (!deveBuscar) {
      setSugestoes([]);
      setIndiceSelecionado(null);
      return undefined;
    }

    timeoutRef.current = setTimeout(() => {
      const controller = new AbortController();
      requisicaoRef.current = controller;

      listarSugestoesChatIa(termoLimpo || undefined, { signal: controller.signal })
        .then(resposta => {
          if (requisicaoRef.current !== controller) return;
          setSugestoes(resposta.data?.data ?? []);
          setIndiceSelecionado(null);
        })
        .catch(erro => {
          if (erro?.name !== 'CanceledError' && erro?.code !== 'ERR_CANCELED') {
            setSugestoes([]);
            setIndiceSelecionado(null);
          }
        });
    }, ATRASO_BUSCA_MS);

    return () => {
      clearTimeout(timeoutRef.current);
      requisicaoRef.current?.abort();
    };
  }, [termo, buscarSemTermo]);

  const moverSelecao = useCallback(
    direcao => {
      if (sugestoes.length === 0) return;

      setIndiceSelecionado(atual => {
        if (atual === null) return direcao > 0 ? 0 : sugestoes.length - 1;
        return (atual + direcao + sugestoes.length) % sugestoes.length;
      });
    },
    [sugestoes.length]
  );

  const sugestaoSelecionada = indiceSelecionado === null ? null : (sugestoes[indiceSelecionado] ?? null);

  return {
    sugestoes,
    indiceSelecionado,
    sugestaoSelecionada,
    setIndiceSelecionado,
    moverSelecao,
    limpar
  };
};

export default useSugestoesHook;
